import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import HomePage from "./pages/HomePage";
import ArticlePage from "./pages/ArticlePage";
import CategoryPage from "./pages/CategoryPage";
import RankingPage from "./pages/RankingPage";
import PlaylistsPage from "./pages/PlaylistsPage";
import PlaylistDetailPage from "./pages/PlaylistDetailPage";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminArticles from "./pages/admin/Articles";
import AdminCreateArticle from "./pages/admin/CreateArticle";
import AdminEditArticle from "./pages/admin/EditArticle";
import AdminAIMonitor from "./pages/admin/AIMonitor";
import AdminArtists from "./pages/admin/Artists";
import AdminMusics from "./pages/admin/Musics";
import AdminAutomation from "./pages/admin/Automation";
import AdminPendingApprovals from "./pages/admin/PendingApprovals";
import AdminSubmissions from "./pages/admin/Submissions";
import AdminDVDs from "./pages/admin/AdminDVDs";
import AdminCDSubmissions from "./pages/admin/CDSubmissions";
import AdminStats from "./pages/admin/Stats";
import AdminBackup from "./pages/admin/Backup";
import AdminVideos from "./pages/admin/Videos";
import AdminYouTubeSync from "./pages/admin/YouTubeSync";
import DivulguePage from "./pages/DivulguePage";
import DVDsPage from "./pages/DVDsPage";
import DVDDetailPage from "./pages/DVDDetailPage";
import VitrinePage from "./pages/VitrinePage";
import VitrineCDsPage from "./pages/VitrineCDsPage";
import CDDetailPage from "./pages/CDDetailPage";
import SendCDPage from "./pages/SendCDPage";
import SendVideoPage from "./pages/SendVideoPage";
import ArtistProfilePage from "./pages/ArtistProfilePage";
import ArtistsDirectoryPage from "./pages/ArtistsDirectoryPage";
import SearchPage from "./pages/SearchPage";
import GenrePage from "./pages/GenrePage";
import ProtectedRoute from "./components/ProtectedRoute";
import MiniPlayer from "./components/MiniPlayer";
import "./App.css";

function App() {
  return (
    <ErrorBoundary>
      <div className="App min-h-screen bg-[#050505] pb-28">
        <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/artigo/:id" element={<ArticlePage />} />
          <Route path="/categoria/:category" element={<CategoryPage />} />
          <Route path="/ranking" element={<RankingPage />} />
          <Route path="/playlists" element={<PlaylistsPage />} />
          <Route path="/playlist/:id" element={<PlaylistDetailPage />} />
          <Route path="/divulgue" element={<DivulguePage />} />
          <Route path="/dvds" element={<DVDsPage />} />
          <Route path="/dvd/:id" element={<DVDDetailPage />} />
          <Route path="/vitrine" element={<VitrinePage />} />
          <Route path="/vitrine-cds" element={<VitrineCDsPage />} />
          <Route path="/cd/:id" element={<CDDetailPage />} />
          <Route path="/envie-seu-cd" element={<SendCDPage />} />
          <Route path="/envie-cd" element={<Navigate to="/envie-seu-cd" replace />} />
          <Route path="/envie-seu-video" element={<SendVideoPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/artistas" element={<ArtistsDirectoryPage />} />
          <Route path="/artista/:slug" element={<ArtistProfilePage />} />
          <Route path="/buscar" element={<SearchPage />} />
          <Route path="/genero/:genre" element={<GenrePage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/automation" element={<ProtectedRoute><AdminAutomation /></ProtectedRoute>} />
          <Route path="/admin/aprovacoes" element={<ProtectedRoute><AdminPendingApprovals /></ProtectedRoute>} />
          <Route path="/admin/articles" element={<ProtectedRoute><AdminArticles /></ProtectedRoute>} />
          <Route path="/admin/articles/create" element={<ProtectedRoute><AdminCreateArticle /></ProtectedRoute>} />
          <Route path="/admin/articles/edit/:id" element={<ProtectedRoute><AdminEditArticle /></ProtectedRoute>} />
          <Route path="/admin/ai-monitor" element={<ProtectedRoute><AdminAIMonitor /></ProtectedRoute>} />
          <Route path="/admin/artists" element={<ProtectedRoute><AdminArtists /></ProtectedRoute>} />
          <Route path="/admin/musics" element={<ProtectedRoute><AdminMusics /></ProtectedRoute>} />
          <Route path="/admin/submissions" element={<ProtectedRoute><AdminSubmissions /></ProtectedRoute>} />
          <Route path="/admin/dvds" element={<ProtectedRoute><AdminDVDs /></ProtectedRoute>} />
          <Route path="/admin/cd-submissions" element={<ProtectedRoute><AdminCDSubmissions /></ProtectedRoute>} />
          <Route path="/admin/video-submissions" element={<ProtectedRoute><AdminVideos /></ProtectedRoute>} />
          <Route path="/admin/youtube" element={<ProtectedRoute><AdminYouTubeSync /></ProtectedRoute>} />
          <Route path="/admin/stats" element={<ProtectedRoute><AdminStats /></ProtectedRoute>} />
          <Route path="/admin/backup" element={<ProtectedRoute><AdminBackup /></ProtectedRoute>} />

          {/* Catch-all: redireciona rotas inexistentes para evitar tela preta */}
          <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
        <MiniPlayer />
        <Toaster position="top-right" richColors />
      </div>
    </ErrorBoundary>
  );
}

export default App;
